import React, { useEffect, useState } from 'react';

import PropertyShow from '../../off_market_properties/property_show';
import { Offcanvas } from 'react-bootstrap-5';
import { connect, useDispatch } from 'react-redux';
import type { Profile } from 'bundles/connect/types';
import {
  clearOffMarketProperty, setOffMarketPropertyId
} from 'bundles/connect/components/store/actions/off_market_property';
import { addUrlParam, clearUrlParam, getUrlParam } from '../helpers/url_helper';
import { trackEvent } from '../helpers/google_analytics_helpers';
import SessionModal from '../../session_modal';

type Props = {
  fromConsole: boolean;
  profile: Profile;
  offcanvasInsightsPropertyId: string;
  setOffMarketPropertyId: (id: string) => void;
}

const OFF_MARKET_URL_PARAM = 'property_id';

function OffMarketPropertyOffcanvas(
  {
    fromConsole,
    profile,
    offcanvasInsightsPropertyId,
    setOffMarketPropertyId
  }: Props
) {
  const [showSessionModal, setShowSessionModal] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(clearOffMarketProperty());
  };

  useEffect(() => {
    const offMarketPropertyId = getUrlParam(OFF_MARKET_URL_PARAM);
    if (offMarketPropertyId) {
      setOffMarketPropertyId(offMarketPropertyId);
    }
  }, []);

  useEffect(() => {
    const clickEvent = (e) => {
      if (e.target?.dataset?.jsStartSessionModal) setShowSessionModal(true);
    };
    window.addEventListener('click', clickEvent);

    return () => window.removeEventListener('click', clickEvent);
  }, []);

  useEffect(() => {
    if (offcanvasInsightsPropertyId) {
      trackEvent('connect_search_off_market_property_modal_open', { propertyId: offcanvasInsightsPropertyId });
      if (history.state?.propertyId !== offcanvasInsightsPropertyId) {
        if (!history.state?.propertyId) {
          history.pushState(
            { propertyId: offcanvasInsightsPropertyId },
            '',
            addUrlParam(OFF_MARKET_URL_PARAM, offcanvasInsightsPropertyId)
          );
        } else {
          history.replaceState(
            { propertyId: offcanvasInsightsPropertyId },
            '',
            addUrlParam(OFF_MARKET_URL_PARAM, offcanvasInsightsPropertyId)
          );
        }
      }
    } else {
      clearUrlParam(OFF_MARKET_URL_PARAM);
    }
  }, [offcanvasInsightsPropertyId]);

  // when user navigates back/forward, check the URL and reassign the propertyId
  useEffect(() => {
    const listener = (e) => {
      setOffMarketPropertyId(e.state?.propertyId);
    };
    window.addEventListener('popstate', listener);

    return () => window.removeEventListener('popstate', listener);
  }, []);


  if (showSessionModal) return <SessionModal onHide={() => setShowSessionModal(false)} />;

  return (
    <Offcanvas
      className="property-offcanvas"
      data-bs-backdrop="false"
      enforceFocus={false}
      placement="end"
      show={!!offcanvasInsightsPropertyId && !showSessionModal}
      onHide={handleClose}
    >
      <Offcanvas.Header className="d-md-none justify-content-end" closeButton />
      {offcanvasInsightsPropertyId && (
        <PropertyShow
          fromConsole={fromConsole}
          fullscreen={false}
          hasProfile={!!profile.id}
          insightsPropertyId={offcanvasInsightsPropertyId}
        />
      )}
    </Offcanvas>
  );
}

const mapStateToProps = ({ ui: { profile }, offMarketProperty: { propertyId } }) => {
  return { profile, offcanvasInsightsPropertyId: propertyId };
};

export default connect(mapStateToProps, { setOffMarketPropertyId })(OffMarketPropertyOffcanvas);
